import React, { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  //useParams,
} from "react-router-dom";

import "../style/OrderSuccess.css";
import successGif from "../../../assets/images/check-green.gif";
import successImage from "../../../assets/images/check-green2.jpg";
import Breadcrumb from "../../../Component/breadcrumb/Breadcrumb";
import { formatDateTime } from "../../../utils/date.utils";

const OrderPlaced = () => {
//   const { cart_temp_token } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [showGif, setShowGif] = useState(true);
  
  const orderResponse = location.state?.orderResponse;
  const orderDetails =  orderResponse?.data || null;

  // =========================================
  // DATA NOT FOUND => HOME
  // =========================================

  useEffect(() => {
    if (
      !orderResponse ||
      !orderResponse?.data ||
      Object.keys(orderResponse.data).length === 0
    ) {
      navigate("/", {
        replace: true,
      });
    }
  }, [orderResponse, navigate]);

  // =========================================
  // GIF
  // =========================================

  const handleGifLoad = () => {
    setTimeout(() => {
      setShowGif(false);
    }, 2000);
  };

  // Redirect hone se pehle blank
  if (!orderDetails) {
    return null;
  }

  console.log(orderDetails,'dd');

  return (
    <>
        <div style={{ textTransform:"uppercase"}}>
      <Breadcrumb
        items={[
          {
            name: ` ${
              orderDetails?.order_no || ""
            }`,
            path: "",
          },
        ]}
      />
      </div>

      <div className="success-container">
        <div className="success-card">

          {/* Success Image */}

          <img
            src={
              showGif
                ? successGif
                : successImage
            }
            alt="Order Successful"
            className="success-icon"
            onLoad={
              showGif
                ? handleGifLoad
                : undefined
            }
            style={{
              margin: "0 auto 15px",
              width: "80px",
            }}
          />

          {/* Heading */}

          <h1>
            🎉 Order Placed!
          </h1>

          {/* Description */}

          <p className="subtitle">
            Thank you for shopping with us.
            Your order has been placed
            successfully and will be processed
            soon.
          </p>

          {/* Confirmation Message */}

          <div className="message-box">
            <i className="bi bi-envelope-check"></i>
            <span>
              A confirmation email & whatsapp
              message has been sent.
            </span>
          </div>

          {/* Order Details */}

          <div className="order-info">
            <div className="info-item info-item001">
              <i className="bi bi-receipt"></i>
              <div className="info-content">
                <small>
                  Order No.
                </small>
                <h4>
                  {orderDetails?.order_no ||
                    "N/A"}
                </h4>
              </div>
            </div>

            <div className="divider"></div>
            <div className="info-item">
              <i className="bi bi-calendar3"></i>
              <div className="info-content">

                <small>
                  Order Date
                </small>

                <h4>
                  {formatDateTime(orderDetails?.created_at)}
                </h4>
              </div>
            </div>
          </div>

          {/* Button */}

          <button
            className="continue-btn"
            onClick={() =>
              navigate("/")
            }
          >
            <i className="bi bi-chevron-left"></i>

            <span>
              Continue Shopping
            </span>
          </button>

        </div>
      </div>
    </>
  );
};

export default OrderPlaced;